if (process.env.NODE_ENV === 'test') {
  window.appConfig = {
    webBaseUrl: 'https://ibms-ui-local.cloud-websites.net',
    apiBaseUrl: 'https://ibms-local.cloud-api.net',
    commissioningBaseUrl: 'https://ibms-commissioning-local.cloud-websites.net',
    auth0ClientID: '1234567890aBcDeF1234567890AbCdEf',
    auth0Domain: 'local.auth-provider.net',
    audience: 'https://ibms-local.cloud-api.net/'
  };
}

const appConfig = window.appConfig;

const auth0Config = {
  domain: appConfig.auth0Domain,
  clientID: appConfig.auth0ClientID,
  audience: appConfig.audience,
  redirectUri:
    process.env.NODE_ENV === 'production' ? `${appConfig.webBaseUrl}/Callback` : 'http://localhost:3000/Callback',
  responseType: 'token id_token',
  scope: 'openid profile read:current_user update:current_user'
};

const apiConfig = {
  cmServiceBulkSoftwareUpdate: `${appConfig.apiBaseUrl}/cm-service/bulk/softwareUpdate`,
  cmServiceGetBulkSoftwareDetails: (bulkSwUpdateId) =>
    `${appConfig.apiBaseUrl}/cm-service/bulk/softwareUpdate/${bulkSwUpdateId}`,
  cmServiceDevices: (id) => `${appConfig.apiBaseUrl}/cm-service/devices/${id}`,
  cmServiceDevicesReboot: (id) => `${appConfig.apiBaseUrl}/cm-service/devices/${id}/reboot`,
  cmServiceDevicesLockUnlock: (id) => `${appConfig.apiBaseUrl}/cm-service/devices/${id}/remote_lock`,
  cmServiceDevicesSoftwareUpdate: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/softwareUpdate`,
  cmServiceSetDirection: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/antenna_direction`,
  cmServiceSetDirectionV2: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/v2/devices/${deviceID}/antenna_direction`,
  cmServiceSetGain: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/electronic_gain`,
  cmServiceDevicesSearch: `${appConfig.apiBaseUrl}/cm-service/devices/_search`,
  cmServiceDevicesSearchV2: `${appConfig.apiBaseUrl}/cm-service/v2/devices/_search`,
  cmServiceDevicesAggregate: `${appConfig.apiBaseUrl}/cm-service/v2/devices/aggregate`,
  cmServiceSchema: (type, version) =>
    `${appConfig.apiBaseUrl}/cm-service/schema?device_type=${type}&sw_version=${version}`,
  cmServiceGetProductTypes: `${appConfig.apiBaseUrl}/cm-service/productTypes`,
  swManagerAvailability: (deviceType) =>
    deviceType === ''
      ? `${appConfig.apiBaseUrl}/swmanager/availability`
      : `${appConfig.apiBaseUrl}/swmanager/availability?device_type=${deviceType}`,
  swManagerGetDefaultSWVersion: `${appConfig.apiBaseUrl}/swmanager/defaultSwVersion`,
  swManagerPatchDefaultSWVersion: `${appConfig.apiBaseUrl}/swmanager/defaultSwVersion`,
  swManagerSoftwareUpload: (sw_identifier) => `${appConfig.apiBaseUrl}/swmanager/software`,
  swManagerSoftwareDelete: (sw_identifier) => `${appConfig.apiBaseUrl}/swmanager/software/${sw_identifier}`,
  swManagerGetDefaultVersions: () => `${appConfig.apiBaseUrl}/swmanager/defaultSwVersion`,

  swManagerGetProtectedDevices: () => `${appConfig.apiBaseUrl}/swmanager/autoupdate/protected/devices`,
  swManagerAddProtectedDevices: () => `${appConfig.apiBaseUrl}/swmanager/autoupdate/protected/devices`,
  swManagerDeleteProtectedDevices: (id) => `${appConfig.apiBaseUrl}/swmanager/autoupdate/protected/devices/${id}`,

  swManagerGetFactoryProtectedDevices: () => `${appConfig.apiBaseUrl}/swmanager/autoupdate/protected/factorydevices`,
  swManagerAddFactoryProtectedDevices: () => `${appConfig.apiBaseUrl}/swmanager/autoupdate/protected/factorydevices`,
  swManagerDeleteFactoryProtectedDevices: (id) =>
    `${appConfig.apiBaseUrl}/swmanager/autoupdate/protected/factorydevices/${id}`,
  swManagerGetAllBeamTables: () => `${appConfig.apiBaseUrl}/swmanager/beamtables`,
  swManagerPutUploadBeamTable: () => `${appConfig.apiBaseUrl}/swmanager/beamtables`,
  swManagerGetBeamTableAccessURL: (id) => `${appConfig.apiBaseUrl}/swmanager/beamtables/${id}`,
  swManagerDeleteBeamTable: (id) => `${appConfig.apiBaseUrl}/swmanager/beamtables/${id}`,

  swManagerGetFeatureToggle: `${appConfig.apiBaseUrl}/swmanager/featureToggle`,
  swManagerPatchFeatureToggle: `${appConfig.apiBaseUrl}/swmanager/featureToggle`,
  swManagerGetAutoUpdateSchedule: `${appConfig.apiBaseUrl}/swmanager/autoUpdateSchedule`,
  swManagerPostAutoUpdateSchedule: `${appConfig.apiBaseUrl}/swmanager/autoUpdateSchedule`,
  pmServiceGetCounters: `${appConfig.apiBaseUrl}/pm-service/getCounters`,
  pmServiceGetAvailableCounters: `${appConfig.apiBaseUrl}/pm-service/availableCounters`,
  cmServiceGetActions: `${appConfig.apiBaseUrl}/cm-service/bulk/softwareUpdate`,
  cmServiceGetActionHistory: `${appConfig.apiBaseUrl}/cm-service/actions`,
  commServiceSearch: `${appConfig.apiBaseUrl}/commissioning-service/commissioning/instances/_search`,
  authServiceGetUserPermission: `${appConfig.apiBaseUrl}/auth-service/mypermission`,
  cmServiceAddComment: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/comments/`,
  cmServiceDeleteComment: (deviceID, commentID) =>
    `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/comments/${commentID}`,
  cmServiceGetAllComments: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/comments/`,
  cmServiceDevicesRaster: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/raster`,
  cmServiceDevicesSetWifi: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/set_wifi`,
  cmServiceDevicesBlinkDeviceLED: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/led`,
  cmServiceDevicesGA2BlinkDeviceLED: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/v2/devices/${deviceID}/led`,
  fmServiceAlarms: `${appConfig.apiBaseUrl}/fm/alarms`,
  fmServiceAlarmAggregate: `${appConfig.apiBaseUrl}/fm/aggregate`,
  bmServiceGetBundle: (bundleId) => `${appConfig.apiBaseUrl}/bundle-manager/bundle/${bundleId}`,
  bmServiceGetConfigParams: () => `${appConfig.apiBaseUrl}/bundle-manager/configParams`,
  bmServiceCreateBundle: `${appConfig.apiBaseUrl}/bundle-manager/bundle`,
  bmServicePatchBundle: (bundleId) => `${appConfig.apiBaseUrl}/bundle-manager/bundle/${bundleId}`,
  bmServiceDeleteBundle: (bundleId) => `${appConfig.apiBaseUrl}/bundle-manager/bundle/${bundleId}`,
  bmServiceGetPodCode: () => `${appConfig.apiBaseUrl}/bundle-manager/code`,
  romComAvailablity: `${appConfig.commissioningBaseUrl}/availability`,
  logServiceEventlog: `${appConfig.apiBaseUrl}/device-log-service/eventlog?rnd=${Date.now()}`, //adding rnd=Date.now() to avoid caching API in browser
  logServiceSearch: `${appConfig.apiBaseUrl}/device-log-service/search?rnd=${Date.now()}`, //adding rnd=Date.now() to avoid caching API in browser
  cmServiceRetrieveEventLog: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}/eventlog`,
  cmServicePatchDeviceById: (deviceID) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceID}`,
  authServiceGetUsers: `${appConfig.apiBaseUrl}/auth-service/users?page=0&per_page=100`,
  authServiceGetRoleUsers: `${appConfig.apiBaseUrl}/auth-service/role_users`,
  authServiceGetRoleList: `${appConfig.apiBaseUrl}/auth-service/role_list`,
  authServiceRoleAssign: `${appConfig.apiBaseUrl}/auth-service/role_assign`,
  authServiceRoleCreate: `${appConfig.apiBaseUrl}/auth-service/role`,
  authServiceRoleUpdate: (roleID) => `${appConfig.apiBaseUrl}/auth-service/role/${roleID}`,
  authServiceRoleDelete: (roleID) => `${appConfig.apiBaseUrl}/auth-service/role/${roleID}`,
  authServiceGetAllPermissions: `${appConfig.apiBaseUrl}/auth-service/definition`,
  deviceGroupsPostDeviceGroup: `${appConfig.apiBaseUrl}/device-groups/group-management`,
  deviceGroupsUpdateDeviceGroup: (deviceGroupId) =>
    `${appConfig.apiBaseUrl}/device-groups/group-management/${deviceGroupId}`,

  deviceGroupsDuplicateDeviceGroup: `${appConfig.apiBaseUrl}/device-groups/group-management/geo/duplicate`,

  deviceGroupsDeleteDeviceGroup: (deviceGroupId) =>
    `${appConfig.apiBaseUrl}/device-groups/group-management/${deviceGroupId}`,
  deviceGroupsSearchUserGroups: `${appConfig.apiBaseUrl}/device-groups/group-management/search/user-groups`,
  deviceGroupsGetDeviceGroup: (deviceGroupId) =>
    `${appConfig.apiBaseUrl}/device-groups/group-management/${deviceGroupId}`,
  deviceGroupsUndoDeviceGroupDeletion: (deviceGroupId) =>
    `${appConfig.apiBaseUrl}/device-groups/group-management/${deviceGroupId}/recover`,
  deviceGroupsSearchGeoPolygons: `${appConfig.apiBaseUrl}/device-groups/group-management/search/user-groups?format=geo`,
  deviceGroupsImportGeoPolygon: `${appConfig.apiBaseUrl}/device-groups/group-management/geo/import`,
  deviceGroupsExportGeoPolygon: (deviceGroupId) =>
    `${appConfig.apiBaseUrl}/device-groups/group-management/geo/export/${deviceGroupId}`,
  deviceGroupsSortGeoPolygons: `${appConfig.apiBaseUrl}/device-groups/group-management/set-order`,
  cmServiceGetHeatmap: (deviceId) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/raster/heatmap`,
  commissionServiceInitiateCommission: `${appConfig.apiBaseUrl}/commissioning-service/commissioning`,
  commissionServiceGetStatusOfCommission: (commissioningId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/commissioning/${commissioningId}`,
  commissionServiceGetRasterInfo: (commissioningId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/commissioning/${commissioningId}/rasterInfo`,
  commissionServiceSetActiveBeam: (commissioningId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/commissioning/${commissioningId}/activeBeam`,
  commissionServiceTerminateCommissionOp: (commissioningId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/commissioning/${commissioningId}`,
  commissionServiceSearchCommissionProcesses: `${appConfig.apiBaseUrl}/commissioning-service/commissioning/instances/_search`,
  commissionServiceGetTwoHopSettings: `${appConfig.apiBaseUrl}/commissioning-service/twoHopAlignment/settings`,
  commissionServiceStartTwoHopAlignment: `${appConfig.apiBaseUrl}/commissioning-service/modules/twoHopAlignment`,
  cmServiceGetRasterRecord: (deviceId, rasterId) =>
    `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/raster/${rasterId}`,
  cmServiceGetRasterRecordsForDevice: (deviceId) =>
    `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/raster?sort=-date`,
  cmServiceRetrieveLatestHeatmapFromDevice: (deviceId) =>
    `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/raster/heatmap`,
  cmServiceInitiateRaster: (deviceId) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/raster`,
  cmServiceStatusQueryGetUri: (actionId) => `${appConfig.apiBaseUrl}/cm-service/actions/${actionId}`,
  commissionServiceGetTwoHopAlignmentStatusInstances: (alignmentId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/modules/twoHopAlignment/${alignmentId}`,
  commissioningServicePostAlignmentBeamInfo: (alignmentId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/modules/twoHopAlignment/${alignmentId}/recommendedBeams`,
  commissioningServiceGetAlignmentBeamInfo: (alignmentId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/modules/twoHopAlignment/${alignmentId}/recommendedBeams`,
  commissionServiceSetServicesActiveBeam: (commissioningId) =>
    `${appConfig.apiBaseUrl}/commissioning-service/commissioning/${commissioningId}/suActiveBeam`,
  commissionServiceCancel: `${appConfig.apiBaseUrl}/commissioning-service/cancel`,
  cmServiceGetRasterSettings: `${appConfig.apiBaseUrl}/cm-service/actions/raster/settings`,
  synthAlertsGet: `${appConfig.apiBaseUrl}/synth-alerts/alerts`,
  synthAlertsPost: `${appConfig.apiBaseUrl}/synth-alerts/alerts`,
  synthAlertsPut: (alertId) => `${appConfig.apiBaseUrl}/synth-alerts/alerts/${alertId}`,
  synthAlertsExport: `${appConfig.apiBaseUrl}/synth-alerts/alerts/export`,
  synthAlertsImport: `${appConfig.apiBaseUrl}/synth-alerts/alerts/import`,
  synthAlertsDelete: (alertId) => `${appConfig.apiBaseUrl}/synth-alerts/alerts/${alertId}`,
  synthAlertsToggleActivation: `${appConfig.apiBaseUrl}/synth-alerts/alerts/toggle-activation`,
  synthAlertsDuplicate: `${appConfig.apiBaseUrl}/synth-alerts/alerts/duplicate`,
  synthAlertsGetListAlertEvents: (alertId) => `${appConfig.apiBaseUrl}/synth-alerts/alerts/${alertId}/events`,
  synthAlertsGetAlertRules: `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules`,
  synthAlertsPostAlertRules: `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules`,
  synthAlertsGetAlertRulesMetrics: `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules/metrics`,
  synthAlertsGetAlertRulesConnectionsInfo: (alertRulesId) =>
    `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules/${alertRulesId}/connections`,
  synthAlertsDeleteAlertRules: (alertRulesId) => `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules/${alertRulesId}`,
  synthAlertsRulesDuplicate: `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules/duplicate`,
  synthAlertsPutAlertRules: (alertRulesId) => `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules/${alertRulesId}`,
  synthAlertsSearchPolygonsAndPivots: `${appConfig.apiBaseUrl}/synth-alerts/alerts/geo/search`,
  synthAlertsRulesGetShortInfo: `${appConfig.apiBaseUrl}/synth-alerts/alerts/rules/short`,
  synthAlertsSetCountOfViewedEvents: (alertId) =>
    `${appConfig.apiBaseUrl}/synth-alerts/alerts/${alertId}/events/set-viewed`,
  cmServiceAddProvisionSu: (deviceId) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/provisionSu`,
  cmServiceDeleteProvisionSu: (deviceId, suId) =>
    `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/provisionSu?su-id=${suId}`,
  cmServiceSetServiceState: (deviceId) => `${appConfig.apiBaseUrl}/cm-service/v2/devices/${deviceId}/setServiceState`,
  cmServiceSetLastSu: (deviceId) => `${appConfig.apiBaseUrl}/cm-service/v2/devices/${deviceId}/gainSettings/setLastSu`,
  cmServiceSetCenterArfcn: (deviceId) => `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/centerArfcn`,
  cmServiceGetArfcnValues: (deviceId, product) =>
    `${appConfig.apiBaseUrl}/cm-service/devices/${deviceId}/centerArfcn/_parameters?product=${product}`,
  cmServiceGetBeamKPIs: (deviceId) => `${appConfig.apiBaseUrl}/cm-service/v2/devices/${deviceId}/getBeamKPIs`
};

export { auth0Config, appConfig, apiConfig };
